import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ProductsTotalsRequest } from '../../../models/ss-api/requests/products.totals.request';
import { DialogService } from '../../../services/modal-dialogs/dialog.service';
import { ssApiService } from '../../../services/ss-api.service';
import { GlobalService } from '../../../services/global.service';
import { ProductTotalsItemArray } from '../../../models/ss-api/responses/product.totals.item';
import { ProductItemBasicsArray } from '../../../models/domain/product.item.basics';
import { SearchHomePageVersionBreakdownRequest } from '../../../models/ss-api/requests/search.home.page.version.breakdown';
import { SearchService } from '../../../services/search.service';
import { GISOrderHistoryDialog } from '../../../../app/dialogs/gis.order.history/gis.order.history.dialog';
import { GISOrderHistoryItemArray } from '../../../../app/models/domain/gis.order.history.item';
import { MemberVersionItemArray } from '@models/domain/member.version.item';

@Component({
    selector: 'member-versions',
    templateUrl: './member.versions.component.html',
    styleUrls: ['./member.versions.component.scss']
})
export class MemberVersionsComponent implements OnInit {

    @Input() versionmode: string;
    @Input() archiveDate: Date;
    IsBusy: boolean = false;
    TotalMembers: number = 0;
    TotalDisplay: string = "Total Members";

    memberVersions: MemberVersionItemArray = [];

    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private searchService: SearchService) { }

    ngOnInit() {
        this.GetMemberVersions();
    }


    OpenVersionResults(versionNumber: string) {
        this.IsBusy = true;
        let request = new SearchHomePageVersionBreakdownRequest();
        request.Version = versionNumber;

        let disposable = this.api.SearchHomePageVersionBreakdown(request).subscribe(result => {
            this.IsBusy = false;
            this.searchService.SetProductOverviewResults(result.Data);
            this.gb.AdvancedSearchClick();

            disposable.unsubscribe();
        });
    }

    async GetMemberVersions() {
        console.log("getting member versions!!!");
        console.log("archive date", this.archiveDate);
        this.IsBusy = true;

        let subscription = this.api.MemberVersions(this.versionmode, this.archiveDate).subscribe(response => {
            subscription.unsubscribe();

            this.IsBusy = false;

            if (!response.Result) {
                return;
            }

            this.memberVersions = response.Data;

            this.TotalMembers = this.memberVersions.reduce((accumulator, obj) => {
                return accumulator + obj.Total;
              }, 0);            

            if (this.versionmode == "legacy"){
                this.TotalDisplay = " v2 Members";
            }
            else{
                this.TotalDisplay = " " + this.versionmode + " Members";
            }

        }, error => {
			console.log("ERROR : ", error);
			this.IsBusy = false;
		});

    }

}
